import { useQuery } from 'react-query';

import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';

import type { AccreditationVersion } from '../../_types/awb';

export async function getAccreditationVersion(accreditationBodyId: string, id: string): Promise<AccreditationVersion> {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${accreditationBodyId}/versions/${id}`;
  const data = await fetcher({
    method: 'get',
    url,
  });
  return data;
}

export default function useAccreditationVersion(
  accreditationBodyId: string,
  id?: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  return useQuery<AccreditationVersion, Error>(
    ['accreditation_version', id],
    () => getAccreditationVersion(accreditationBodyId, id!),
    {
      ...options,
      enabled: !!id,
    }
  );
}
